import React from 'react';
import { ServicesContext } from '~/services';
import { BSModal } from '~/components/Bootstrap';
import { Modal, Spinner } from 'react-bootstrap';

export function EmailNotificationSettings() {
    const servicesContext = React.useContext(ServicesContext);
    const { savedNotificationOptions } = servicesContext.user.getSavedSearchData();
    const storedEnabled = React.useRef(
        (savedNotificationOptions?.email?.openTA as boolean) || false
    );
    const [show, setShow] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [enabled, setEnabled] = React.useState(
        (savedNotificationOptions?.email?.openTA as boolean) || false
    );

    async function save() {
        setLoading(true);
        await servicesContext.user.setSavedSearchData('notification_options', {
            ...savedNotificationOptions,
            email: {
                openTA: enabled,
            },
        });
        setLoading(false);
        storedEnabled.current = enabled;
        setShow(false);
    }

    function cancel() {
        setEnabled(storedEnabled.current);
        setShow(false);
    }

    if (!servicesContext.user.hasFeatureToggle('email_notification_settings')) return null;

    return (
        <div className="row align-items-center mt-2">
            <div className="col-3 text-end">
                <div>Email</div>
            </div>
            <div className="col-3">{storedEnabled.current ? 'Enabled' : 'Disabled'}</div>
            <div className="col-6 text-end text-nowrap">
                <button className="btn btn-primary" type="button" onClick={() => setShow(true)}>
                    Options
                </button>
                <BSModal
                    show={show}
                    onHide={cancel}
                    aria-labelledby="email-notification-settings-modal"
                >
                    <Modal.Header closeButton>
                        <Modal.Title
                            id="email-notification-settings-modal"
                            role="heading"
                            aria-level={1}
                        >
                            Email Notification Settings
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <label className="form-label align-baseline">
                            <input
                                type="checkbox"
                                className="align-middle"
                                checked={enabled}
                                onChange={(e) => setEnabled(e.target.checked)}
                            />
                            <span className="ms-2">
                                Receive daily updates when the system creates a new Timely Action.
                            </span>
                        </label>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary" onClick={cancel}>
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={save}
                            disabled={loading}
                        >
                            {loading && (
                                <Spinner
                                    animation="border"
                                    className="me-1"
                                    role="status"
                                    size="sm"
                                    variant="light"
                                />
                            )}
                            Save
                        </button>
                    </Modal.Footer>
                </BSModal>
            </div>
        </div>
    );
}
